import React from "react";
import { ReactComponent as PlusSVG } from "./assets/plus.svg";
import { ReactComponent as MinusSVG } from "./assets/minus.svg";
import { ReactComponent as AutoSVG } from "./assets/auto.svg";
import { ReactComponent as MenuSVG } from "./assets/menu.svg";
import { colors } from "./colors";
export const settings = [
  {
    icon: <MenuSVG />,
    title: "Settings button",
    description: "Press the button to access Settings",
    background: colors.primary,
  },
  {
    title: "Provably Fair",
    description:
      "This section grants you the possibility of checking the fairness of the game for yourself",
  },
  {
    title: "Game Rules",
    description: "Short Description of the Game",
  },
  {
    title: "History",
    description:
      "Shows your previous plays and allows you to devise newtactics for your next shuffle",
  },
  {
    title: "Music",
    description: "Turn on the unique audio overlay of the game",
  },
  {
    title: "Sound",
    description: "Enable unique action sounds of Mines",
  },
  {
    title: "Volume Bar",
    description: "Set the volume",
  },
];
export const gamePlayCustomatization = [
  {
    icon: "Play",
    title: "Play Button",
    description: "Start the Game",
    textColor: colors.textColor,
    width: "72px",
  },
  {
    icon: "2X",
    title: "2x Button",
    textColor: colors.textColor,
    description: "Doubles your bet instantly",
  },
  {
    icon: "1/2",
    title: "1/2 Button",
    textColor: colors.textColor,
    description: "Divides your bet by half",
  },
];
export const gamePlayCustomatizationOptions = [
  {
    icon: "5X",
    title: "5x Button",
    textColor: colors.textColor,
    description: "Multiply your bet by 5",
  },
  {
    icon: <PlusSVG />,
    title: "+ Button",
    description: "Increase amount by a single unit",
  },
  {
    icon: <MinusSVG />,
    title: "- Button",
    description: "Decrease amount by a single unit",
  },
  {
    icon: <AutoSVG />,
    title: "Auto Button",
    description: "Switch to auto interface",
  },
];
export const autoPlay = [
  { title: "Number of Bets", description: "Set the Number of Your Bets" },
  {
    title: "On Win",
    description:
      "In this field you can input an option to increase or decrease the bet percentage after the winning hand",
  },
  {
    title: "On Loss",
    description: `In this field you can input an option to increase
  or decrease the bet percentage after the losing hand`,
  },
  {
    title: "Stop on Profit",
    description: `Enables you to stop autoplay when a certain
  profit number is reached`,
  },
  {
    title: "Stop on Loss",
    description: `Enables you to stop autoplay when a certain
  amount is lost`,
  },
  {
    icon: <PlusSVG />,
    title: "+ Button",
    description: "Increase amount by a single unit",
  },
  {
    icon: <MinusSVG />,
    title: "- Button",
    description: "Decrease amount by a single unit",
  },
];
